/**
 * Lightweight, opt-in dynamic favicon controller.
 *
 * Swaps the href of <link id="dynamic-favicon"> between three states:
 *   - idle      → /icons/loopy_32.png
 *   - loading   → /icons/loopy_loading.png
 *   - good job  → /icons/loopy_goodjob.png (auto-reverts to idle)
 *
 * Call sites opt in by importing { setLoading, setIdle, pulseGoodJob }.
 * Nothing here auto-instruments the app — wire it into specific flows
 * (form submit, async save, etc.) deliberately.
 */

const IDLE = '/icons/loopy_32.png';
const LOADING = '/icons/loopy_loading.png';
const GOODJOB = '/icons/loopy_goodjob.png';
const ELEMENT_ID = 'dynamic-favicon';

let goodJobTimer: number | null = null;

function getLink(): HTMLLinkElement | null {
  if (typeof document === 'undefined') return null;
  return document.getElementById(ELEMENT_ID) as HTMLLinkElement | null;
}

function setHref(href: string): void {
  const link = getLink();
  if (link) link.href = href;
}

export function setLoading(): void {
  if (goodJobTimer !== null) {
    window.clearTimeout(goodJobTimer);
    goodJobTimer = null;
  }
  setHref(LOADING);
}

export function setIdle(): void {
  if (goodJobTimer !== null) {
    window.clearTimeout(goodJobTimer);
    goodJobTimer = null;
  }
  setHref(IDLE);
}

export function pulseGoodJob(durationMs = 1500): void {
  if (goodJobTimer !== null) {
    window.clearTimeout(goodJobTimer);
  }
  setHref(GOODJOB);
  goodJobTimer = window.setTimeout(() => {
    setHref(IDLE);
    goodJobTimer = null;
  }, durationMs);
}
